// Cart drawer "Get Member Price" offer (snippets/cart-vip-offer.liquid): adds the
// membership with its subscription plan, then re-renders the drawer in place.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-vip-cart-add]');
  if (!button || button.disabled) return;
  event.preventDefault();

  const offer = button.closest('.cart-vip-offer');
  const error = offer?.querySelector('[data-vip-cart-error]');
  if (error) error.hidden = true;
  button.disabled = true;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variant), quantity: 1, selling_plan: Number(button.dataset.sellingPlan) }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');

    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && data.sections) {
      drawer.renderContents(data, true);
    } else {
      window.location.reload();
    }
  } catch (e) {
    button.disabled = false;
    if (error) error.hidden = false;
  }
});
